import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { Befehl31 } from '../../../models'
import { Befehl31FormData, createBefehl31FormValidationSchema } from './schema'
import { useTranslation } from 'react-i18next'
import {
  convertBefehl31FormDataToModel,
  convertModelToBefehl31FormData
} from './converters'
import { useCallback } from 'react'
import { useBefehlForm } from '../../../hooks'
import Auftrag31_10Form from './Auftrag31_10Form'

export default function Befehl31Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-31-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl31>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl31FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl31FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl31FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl31FormData) => {
      const updatedBefehl = convertBefehl31FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl31FormData>
      befehlKennung="31"
      title={t('befehle.31.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      <Auftrag31_10Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-31-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
